// Viewport height handler for mobile browsers
export function setupViewportHandler() {
  if (typeof window !== 'undefined') {
    // Function to update the CSS variable with the actual viewport height
    const updateVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Initial call
    updateVh();

    // Add event listeners for when viewport size changes
    window.addEventListener('resize', updateVh);
    window.addEventListener('orientationchange', updateVh);

    // Return cleanup function
    return () => {
      window.removeEventListener('resize', updateVh);
      window.removeEventListener('orientationchange', updateVh);
    };
  }
  
  return () => {}; // Return empty function if not in browser
} 